angular.module('lf.desktop')

.directive('miniCartLoadingOverlay', function () {
  return {
    restrict: 'A',
    scope: true,
    link: function (scope, el, attrs) {
      var $overlay = el.find('.mini-cart__loading-overlay');
      
      scope.$on('cart:requesting', toggle);
      scope.$on('wishlist:requesting', toggle);
      
      function toggle (e, requesting) {
        e.stopPropagation();
        if (requesting) {
          $overlay.show();
        } else {
          $overlay.hide();
        }
      }
    }
  }
});
